import { AuthContext as e, AuthorizedApiBase as t } from "@urbanx/agx.auth.client";
import n from "axios";
import { c as r } from "react/compiler-runtime";
import { jsx as i } from "react/jsx-runtime";
import { createContext as a, useContext as o, useEffect as s, useState as c } from "react";
import { useMutation as l, useQuery as u, useQueryClient as d } from "@tanstack/react-query";
//#region src/Client.ts
var f = class extends t {
	instance;
	baseUrl;
	jsonParseReviver = void 0;
	constructor(e, t) {
		super(), this.instance = t || n.create(), this.baseUrl = e ?? "http://127.0.0.1:7080/Rex";
	}
	getActiveListingsForAgency(e, t) {
		let n = this.baseUrl + "/GetActiveListingsForAgency?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetActiveListingsForAgency(e)));
	}
	processGetActiveListingsForAgency(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getAgencyListingsPermanentLinkModel(e, t) {
		let n = this.baseUrl + "/GetAgencyListingsPermanentLinkModel?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetAgencyListingsPermanentLinkModel(e)));
	}
	processGetAgencyListingsPermanentLinkModel(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("Invalid agency Id supplied", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("Unauthorized request", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return A("Brand account Id not found", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getAgentRexDetails(e, t) {
		let n = this.baseUrl + "/GetAgentRexDetails?";
		if (e == null) throw new globalThis.Error("The parameter 'agentId' must be defined and cannot be null.");
		n += "agentId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetAgentRexDetails(e)));
	}
	processGetAgentRexDetails(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getLeaderboardStatisticsForEntity(e, t) {
		let n = this.baseUrl + "/GetLeaderboardStatisticsForEntity";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetLeaderboardStatisticsForEntity(e)));
	}
	processGetLeaderboardStatisticsForEntity(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getListingByCampaignId(e, t) {
		let n = this.baseUrl + "/GetListingByCampaignId?";
		if (e == null) throw new globalThis.Error("The parameter 'campaignId' must be defined and cannot be null.");
		n += "campaignId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetListingByCampaignId(e)));
	}
	processGetListingByCampaignId(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("Invalid campaign Id supplied", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("Unauthorized request", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getPartnershipInformation(e, t) {
		let n = this.baseUrl + "/GetPartnershipInformation";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetPartnershipInformation(e)));
	}
	processGetPartnershipInformation(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getStatisticsForEntity(e, t) {
		let n = this.baseUrl + "/GetStatisticsForEntity";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetStatisticsForEntity(e)));
	}
	processGetStatisticsForEntity(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getSuburbs(e, t) {
		let n = this.baseUrl + "/GetSuburbs";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetSuburbs(e)));
	}
	processGetSuburbs(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getTopPerformers(e) {
		let t = this.baseUrl + "/GetTopPerformers";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "GET",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetTopPerformers(e)));
	}
	processGetTopPerformers(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	setListingPublishedToPortal(e, t) {
		let n = this.baseUrl + "/SetListingPublishedToPortal";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processSetListingPublishedToPortal(e)));
	}
	processSetListingPublishedToPortal(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetAgencyPartnershipDetails(e, t, n) {
		let r = this.baseUrl + "/StaffGetAgencyPartnershipDetails?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent("" + e) + "&", t != null && (r += "specificAnniversaryDate=" + encodeURIComponent(t ? "" + t.toISOString() : "") + "&"), r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processStaffGetAgencyPartnershipDetails(e)));
	}
	processStaffGetAgencyPartnershipDetails(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetCurrentPartnershipInformation(e, t, n, r) {
		let i = this.baseUrl + "/StaffGetCurrentPartnershipInformation?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		i += "agencyId=" + encodeURIComponent("" + e) + "&", t != null && (i += "anniversaryDateToUse=" + encodeURIComponent(t ? "" + t.toISOString() : "") + "&"), n != null && (i += "previousYear=" + encodeURIComponent("" + n) + "&"), i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processStaffGetCurrentPartnershipInformation(e)));
	}
	processStaffGetCurrentPartnershipInformation(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetEntityNumbers(e, t) {
		let n = this.baseUrl + "/StaffGetEntityNumbers";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetEntityNumbers(e)));
	}
	processStaffGetEntityNumbers(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetUpcomingSettlementsForAgency(e, t) {
		let n = this.baseUrl + "/StaffGetUpcomingSettlementsForAgency?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		n += "agencyId=" + encodeURIComponent("" + e) + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processStaffGetUpcomingSettlementsForAgency(e)));
	}
	processStaffGetUpcomingSettlementsForAgency(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	updateAgentRexDetails(e, t) {
		let n = this.baseUrl + "/UpdateAgentRexDetails";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "PUT",
			url: n,
			headers: { "Content-Type": "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processUpdateAgentRexDetails(e)));
	}
	processUpdateAgentRexDetails(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	createLead(e, t) {
		let n = this.baseUrl + "/CreateLead";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processCreateLead(e)));
	}
	processCreateLead(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getPublishedListingDetail(e, t, n) {
		let r = this.baseUrl + "/GetPublishedListingDetail?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		if (r += "agencyId=" + encodeURIComponent("" + e) + "&", t == null) throw new globalThis.Error("The parameter 'listingId' must be defined and cannot be null.");
		r += "listingId=" + encodeURIComponent("" + t) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			method: "GET",
			url: r,
			headers: { Accept: "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processGetPublishedListingDetail(e)));
	}
	processGetPublishedListingDetail(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getPublishedListingDetails(e) {
		let t = this.baseUrl + "/GetPublishedListingDetails";
		t = t.replace(/[?&]$/, "");
		let n = {
			method: "POST",
			url: t,
			headers: { Accept: "application/json" },
			signal: e
		};
		return this.transformOptions(n).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(t, e, (e) => this.processGetPublishedListingDetails(e)));
	}
	processGetPublishedListingDetails(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t === 404) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getPublishedListingsAgentsAndSuburbs(e, t, n, r) {
		let i = this.baseUrl + "/GetPublishedListingsAgentsAndSuburbs?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		i += "agencyId=" + encodeURIComponent("" + e) + "&", t != null && (i += "listingState=" + encodeURIComponent("" + t) + "&"), n != null && n && n.forEach((e) => {
			i += "listingCategories=" + encodeURIComponent("" + e) + "&";
		}), i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetPublishedListingsAgentsAndSuburbs(e)));
	}
	processGetPublishedListingsAgentsAndSuburbs(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	rexBrandAccountWebhook(e, t, n) {
		let r = this.baseUrl + "/RexBrandAccountWebhook?";
		if (e == null) throw new globalThis.Error("The parameter 'agencyId' must be defined and cannot be null.");
		r += "agencyId=" + encodeURIComponent("" + e) + "&", r = r.replace(/[?&]$/, "");
		let i = {
			data: JSON.stringify(t),
			method: "POST",
			url: r,
			headers: { "Content-Type": "application/json" },
			signal: n
		};
		return this.transformOptions(i).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(r, e, (e) => this.processRexBrandAccountWebhook(e)));
	}
	processRexBrandAccountWebhook(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) return e.data, Promise.resolve(null);
		if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	staffGetLeaderboardStatistics(e, t, n, r, i, a) {
		let o = this.baseUrl + "/StaffGetLeaderboardStatistics?";
		e != null && (o += "contractDateToUse=" + encodeURIComponent("" + e) + "&"), t != null && (o += "fromDate=" + encodeURIComponent(t ? "" + t.toISOString() : "") + "&"), n != null && (o += "toDate=" + encodeURIComponent(n ? "" + n.toISOString() : "") + "&"), r != null && (o += "statisticsType=" + encodeURIComponent("" + r) + "&"), i != null && (o += "statisticsTimePeriod=" + encodeURIComponent("" + i) + "&"), o = o.replace(/[?&]$/, "");
		let s = {
			method: "GET",
			url: o,
			headers: { Accept: "application/json" },
			signal: a
		};
		return this.transformOptions(s).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(o, e, (e) => this.processStaffGetLeaderboardStatistics(e)));
	}
	processStaffGetLeaderboardStatistics(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return A("No description", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	exportNetworkItemizedTransactions(e, t) {
		let n = this.baseUrl + "/ExportNetworkItemizedTransactions";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			responseType: "blob",
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "text/csv"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processExportNetworkItemizedTransactions(e)));
	}
	processExportNetworkItemizedTransactions(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 401) {
			let r = e.data;
			return A("Unauthorized request", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getContractCommissionDiscrepancies(e, t, n, r) {
		let i = this.baseUrl + "/GetContractCommissionDiscrepancies?";
		e != null && (i += "periodStart=" + encodeURIComponent(e ? "" + e.toISOString() : "") + "&"), t != null && (i += "periodEnd=" + encodeURIComponent(t ? "" + t.toISOString() : "") + "&"), n != null && (i += "filterByAnniversaryDate=" + encodeURIComponent("" + n) + "&"), i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetContractCommissionDiscrepancies(e)));
	}
	processGetContractCommissionDiscrepancies(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("Invalid request parameters", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("Unauthorized request", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getExecutiveKeyMetrics(e, t) {
		let n = this.baseUrl + "/GetExecutiveKeyMetrics?";
		if (e == null) throw new globalThis.Error("The parameter 'month' must be defined and cannot be null.");
		n += "month=" + encodeURIComponent(e ? "" + e.toISOString() : "") + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetExecutiveKeyMetrics(e)));
	}
	processGetExecutiveKeyMetrics(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getExecutiveRunRateMetrics(e, t) {
		let n = this.baseUrl + "/GetExecutiveRunRateMetrics?";
		if (e == null) throw new globalThis.Error("The parameter 'month' must be defined and cannot be null.");
		n += "month=" + encodeURIComponent(e ? "" + e.toISOString() : "") + "&", n = n.replace(/[?&]$/, "");
		let r = {
			method: "GET",
			url: n,
			headers: { Accept: "application/json" },
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetExecutiveRunRateMetrics(e)));
	}
	processGetExecutiveRunRateMetrics(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getListingDiscrepancies(e, t, n, r) {
		let i = this.baseUrl + "/GetListingDiscrepancies?";
		e != null && (i += "periodStart=" + encodeURIComponent(e ? "" + e.toISOString() : "") + "&"), t != null && (i += "periodEnd=" + encodeURIComponent(t ? "" + t.toISOString() : "") + "&"), n != null && (i += "filterByAnniversaryDate=" + encodeURIComponent("" + n) + "&"), i = i.replace(/[?&]$/, "");
		let a = {
			method: "GET",
			url: i,
			headers: { Accept: "application/json" },
			signal: r
		};
		return this.transformOptions(a).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(i, e, (e) => this.processGetListingDiscrepancies(e)));
	}
	processGetListingDiscrepancies(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t === 400) {
			let r = e.data;
			return A("Invalid request parameters", t, r, n);
		} else if (t === 401) {
			let r = e.data;
			return A("Unauthorized request", t, r, n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getNetworkPartnershipMetrics(e, t) {
		let n = this.baseUrl + "/GetNetworkPartnershipMetrics";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetNetworkPartnershipMetrics(e)));
	}
	processGetNetworkPartnershipMetrics(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
	getNetworkStateMetrics(e, t) {
		let n = this.baseUrl + "/GetNetworkStateMetrics";
		n = n.replace(/[?&]$/, "");
		let r = {
			data: JSON.stringify(e),
			method: "POST",
			url: n,
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json"
			},
			signal: t
		};
		return this.transformOptions(r).then((e) => this.instance.request(e)).catch((e) => {
			if (j(e) && e.response) return e.response;
			throw e;
		}).then((e) => this.transformResult(n, e, (e) => this.processGetNetworkStateMetrics(e)));
	}
	processGetNetworkStateMetrics(e) {
		let t = e.status, n = {};
		if (e.headers && typeof e.headers == "object") for (let t in e.headers) e.headers.hasOwnProperty(t) && (n[t] = e.headers[t]);
		if (t === 200) {
			let t = e.data, n = null;
			return n = t, Promise.resolve(n);
		} else if (t !== 200 && t !== 204) {
			let r = e.data;
			return A("An unexpected server error occurred.", t, r, n);
		}
		return Promise.resolve(null);
	}
}, p = /* @__PURE__ */ function(e) {
	return e.Current = "Current", e.Sold = "Sold", e.Withdrawn = "Withdrawn", e.Leased = "Leased", e;
}({}), m = /* @__PURE__ */ function(e) {
	return e.BusinessSale = "BusinessSale", e.CommercialRental = "CommercialRental", e.CommercialSale = "CommercialSale", e.CommercialSaleRental = "CommercialSaleRental", e.HolidayRental = "HolidayRental", e.LandSale = "LandSale", e.ResidentialRental = "ResidentialRental", e.ResidentialSale = "ResidentialSale", e.RuralSale = "RuralSale", e;
}({}), h = /* @__PURE__ */ function(e) {
	return e.Written = "Written", e.Unconditional = "Unconditional", e.Settled = "Settled", e.ExpectedSettlement = "ExpectedSettlement", e;
}({}), g = /* @__PURE__ */ function(e) {
	return e.IndividualOrTeam = "IndividualOrTeam", e.Agency = "Agency", e.Partnership = "Partnership", e;
}({}), _ = /* @__PURE__ */ function(e) {
	return e.Month = "Month", e.Quarter = "Quarter", e.Annual = "Annual", e.Previous = "Previous", e.Custom = "Custom", e.ThisPartnershipYear = "ThisPartnershipYear", e.LastPartnershipYear = "LastPartnershipYear", e;
}({}), v = /* @__PURE__ */ function(e) {
	return e.General = "General", e.AppraisalRequest = "AppraisalRequest", e.ListingEnquiry = "ListingEnquiry", e;
}({}), y = /* @__PURE__ */ function(e) {
	return e.Written = "Written", e.Unconditional = "Unconditional", e.Settled = "Settled", e.ExpectedSettlement = "ExpectedSettlement", e;
}({}), b = /* @__PURE__ */ function(e) {
	return e.Month = "Month", e.Quarter = "Quarter", e.Annual = "Annual", e.Previous = "Previous", e.Custom = "Custom", e.ThisPartnershipYear = "ThisPartnershipYear", e.LastPartnershipYear = "LastPartnershipYear", e;
}({}), x = /* @__PURE__ */ function(e) {
	return e.WholeNumber = "WholeNumber", e.Currency = "Currency", e.Percentage = "Percentage", e;
}({}), S = /* @__PURE__ */ function(e) {
	return e.Silver = "Silver", e.Gold = "Gold", e.Platinum = "Platinum", e.XPartner = "XPartner", e.Bronze = "Bronze", e;
}({}), C = /* @__PURE__ */ function(e) {
	return e.Silver = "Silver", e.Gold = "Gold", e.Platinum = "Platinum", e.XPartner = "XPartner", e.Bronze = "Bronze", e;
}({}), w = /* @__PURE__ */ function(e) {
	return e.Silver = "Silver", e.Gold = "Gold", e.Platinum = "Platinum", e.XPartner = "XPartner", e.Bronze = "Bronze", e;
}({}), T = /* @__PURE__ */ function(e) {
	return e.Available = "Available", e.UnderOffer = "UnderOffer", e.Sold = "Sold", e;
}({}), E = /* @__PURE__ */ function(e) {
	return e.VirtualTour = "VirtualTour", e.VideoLink = "VideoLink", e.InteractiveFloorPlan = "InteractiveFloorPlan", e.MiniWeb = "MiniWeb", e.ExternalLink = "ExternalLink", e.Unknown = "Unknown", e;
}({}), ee = /* @__PURE__ */ function(e) {
	return e.WholeNumber = "WholeNumber", e.Currency = "Currency", e.Percentage = "Percentage", e;
}({}), D = /* @__PURE__ */ function(e) {
	return e.IndividualOrTeam = "IndividualOrTeam", e.Agency = "Agency", e.Partnership = "Partnership", e;
}({}), O = /* @__PURE__ */ function(e) {
	return e.Month = "Month", e.Quarter = "Quarter", e.Annual = "Annual", e.Previous = "Previous", e.Custom = "Custom", e.ThisPartnershipYear = "ThisPartnershipYear", e.LastPartnershipYear = "LastPartnershipYear", e;
}({}), k = class extends Error {
	message;
	status;
	response;
	headers;
	result;
	constructor(e, t, n, r, i) {
		super(), this.message = e, this.status = t, this.response = n, this.headers = r, this.result = i;
	}
	isRexApiException = !0;
	static isRexApiException(e) {
		return e.isRexApiException === !0;
	}
};
function A(e, t, n, r, i) {
	throw i ?? new k(e, t, n, r, null);
}
function j(e) {
	return e && e.isAxiosError === !0;
}
//#endregion
//#region src/useClientContext.tsx
var M = "rex";
function N(e) {
	let t = Object.getPrototypeOf(e);
	for (let n of Object.getOwnPropertyNames(t)) {
		let r = t[n];
		typeof r == "function" && n !== "constructor" && (e[n] = r.bind(e));
	}
	return e;
}
var P = (e, t, n) => {
	let r = new f(e);
	return r.setAuthConfig(t, n), N(r);
}, F = ({ baseApiUri: e, devMode: t, localUris: n }) => {
	if (!e) throw console.error("Base API URI is undefined"), Error("Base API URI is undefined");
	let r = n?.rex;
	return t && r ? r : `${e}/rex`;
}, I = (t) => {
	let n = r(10), { agxConfig: i } = t, { getAuthToken: a } = o(e), l, u, d;
	n[0] !== i || n[1] !== a ? (l = F(i), u = c, d = P(l, a, i), n[0] = i, n[1] = a, n[2] = l, n[3] = u, n[4] = d) : (l = n[2], u = n[3], d = n[4]);
	let [f, p] = u(d), m, h;
	return n[5] !== i || n[6] !== l || n[7] !== a ? (m = () => {
		p(P(l, a, i));
	}, h = [
		a,
		i,
		l
	], n[5] = i, n[6] = l, n[7] = a, n[8] = m, n[9] = h) : (m = n[8], h = n[9]), s(m, h), f;
}, L = a({}), R = (e) => {
	let t = r(5), { appConfig: n, children: a } = e, o;
	t[0] === n ? o = t[1] : (o = { agxConfig: n }, t[0] = n, t[1] = o);
	let s = I(o);
	if (!s) return null;
	let c;
	return t[2] !== s || t[3] !== a ? (c = /* @__PURE__ */ i(L.Provider, {
		value: s,
		children: a
	}), t[2] = s, t[3] = a, t[4] = c) : c = t[4], c;
}, z = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(L), s;
	n[0] === e ? s = n[1] : (s = ["getActiveListingsForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getActiveListingsForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, B = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getActiveListingsForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, V = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(L), s;
	n[0] === e ? s = n[1] : (s = ["getAgencyListingsPermanentLinkModel", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getAgencyListingsPermanentLinkModel(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, H = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getAgencyListingsPermanentLinkModel", e] });
	}, e[0] = t, e[1] = n), n;
}, U = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(L), s;
	n[0] === e ? s = n[1] : (s = ["getAgentRexDetails", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.getAgentRexDetails(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, W = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getAgentRexDetails", e] });
	}, e[0] = t, e[1] = n), n;
}, G = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.getLeaderboardStatisticsForEntity(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		getLeaderboardStatisticsForEntity: u,
		getLeaderboardStatisticsForEntityPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, K = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(L), s;
	n[0] === e ? s = n[1] : (s = ["getListingByCampaignId", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getListingByCampaignId(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, q = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getListingByCampaignId", e] });
	}, e[0] = t, e[1] = n), n;
}, J = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.getPartnershipInformation(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		getPartnershipInformation: u,
		getPartnershipInformationPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Y = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.getStatisticsForEntity(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		getStatisticsForEntity: u,
		getStatisticsForEntityPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, X = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.getSuburbs(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		getSuburbs: u,
		getSuburbsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, te = (e) => {
	let t = r(10), n = e === void 0 ? !0 : e, i = o(L), a;
	t[0] === Symbol.for("react.memo_cache_sentinel") ? (a = ["getTopPerformers"], t[0] = a) : a = t[0];
	let s;
	t[1] === i ? s = t[2] : (s = (e) => {
		let { signal: t } = e;
		return i.getTopPerformers(t);
	}, t[1] = i, t[2] = s);
	let c = n && !!i, l;
	t[3] !== s || t[4] !== c ? (l = {
		queryKey: a,
		queryFn: s,
		enabled: c
	}, t[3] = s, t[4] = c, t[5] = l) : l = t[5];
	let { data: d, isPending: f, isError: p } = u(l), m;
	return t[6] !== d || t[7] !== p || t[8] !== f ? (m = {
		data: d,
		isPending: f,
		isError: p
	}, t[6] = d, t[7] = p, t[8] = f, t[9] = m) : m = t[9], m;
}, Z = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async () => {
		await t.invalidateQueries({ queryKey: ["getTopPerformers"] });
	}, e[0] = t, e[1] = n), n;
}, Q = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.setListingPublishedToPortal(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		setListingPublishedToPortal: u,
		setListingPublishedToPortalPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ne = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(L), c;
	i[0] !== e || i[1] !== t ? (c = [
		"staffGetAgencyPartnershipDetails",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== s || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.staffGetAgencyPartnershipDetails(e, t, r);
	}, i[3] = e, i[4] = s, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, re = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetAgencyPartnershipDetails",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, ie = (e, t, n, i) => {
	let a = r(17), s = i === void 0 ? !0 : i, c = o(L), l;
	a[0] !== e || a[1] !== t || a[2] !== n ? (l = [
		"staffGetCurrentPartnershipInformation",
		e,
		t,
		n
	], a[0] = e, a[1] = t, a[2] = n, a[3] = l) : l = a[3];
	let d = l, f;
	a[4] !== e || a[5] !== t || a[6] !== c || a[7] !== n ? (f = (r) => {
		let { signal: i } = r;
		return c.staffGetCurrentPartnershipInformation(e, t, n, i);
	}, a[4] = e, a[5] = t, a[6] = c, a[7] = n, a[8] = f) : f = a[8];
	let p = s && !!c, m;
	a[9] !== d || a[10] !== f || a[11] !== p ? (m = {
		queryKey: d,
		queryFn: f,
		enabled: p
	}, a[9] = d, a[10] = f, a[11] = p, a[12] = m) : m = a[12];
	let { data: h, isPending: g, isError: _ } = u(m), v;
	return a[13] !== h || a[14] !== _ || a[15] !== g ? (v = {
		data: h,
		isPending: g,
		isError: _
	}, a[13] = h, a[14] = _, a[15] = g, a[16] = v) : v = a[16], v;
}, ae = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetCurrentPartnershipInformation",
			e,
			n,
			r
		] });
	}, e[0] = t, e[1] = n), n;
}, oe = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.staffGetEntityNumbers(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		staffGetEntityNumbers: u,
		staffGetEntityNumbersPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, se = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(L), s;
	n[0] === e ? s = n[1] : (s = ["staffGetUpcomingSettlementsForAgency", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== e || n[3] !== a ? (l = (t) => {
		let { signal: n } = t;
		return a.staffGetUpcomingSettlementsForAgency(e, n);
	}, n[2] = e, n[3] = a, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, ce = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["staffGetUpcomingSettlementsForAgency", e] });
	}, e[0] = t, e[1] = n), n;
}, le = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.updateAgentRexDetails(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		updateAgentRexDetails: u,
		updateAgentRexDetailsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, ue = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.createLead(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		createLead: u,
		createLeadPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, de = (e, t, n) => {
	let i = r(15), a = n === void 0 ? !0 : n, s = o(L), c;
	i[0] !== e || i[1] !== t ? (c = [
		"getPublishedListingDetail",
		e,
		t
	], i[0] = e, i[1] = t, i[2] = c) : c = i[2];
	let l = c, d;
	i[3] !== e || i[4] !== s || i[5] !== t ? (d = (n) => {
		let { signal: r } = n;
		return s.getPublishedListingDetail(e, t, r);
	}, i[3] = e, i[4] = s, i[5] = t, i[6] = d) : d = i[6];
	let f = a && !!s, p;
	i[7] !== l || i[8] !== d || i[9] !== f ? (p = {
		queryKey: l,
		queryFn: d,
		enabled: f
	}, i[7] = l, i[8] = d, i[9] = f, i[10] = p) : p = i[10];
	let { data: m, isPending: h, isError: g } = u(p), _;
	return i[11] !== m || i[12] !== g || i[13] !== h ? (_ = {
		data: m,
		isPending: h,
		isError: g
	}, i[11] = m, i[12] = g, i[13] = h, i[14] = _) : _ = i[14], _;
}, fe = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n) => {
		await t.invalidateQueries({ queryKey: [
			"getPublishedListingDetail",
			e,
			n
		] });
	}, e[0] = t, e[1] = n), n;
}, pe = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async () => a.getPublishedListingDetails(), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		getPublishedListingDetails: u,
		getPublishedListingDetailsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, me = (e, t, n, i) => {
	let a = r(17), s = i === void 0 ? !0 : i, c = o(L), l;
	a[0] !== e || a[1] !== n || a[2] !== t ? (l = [
		"getPublishedListingsAgentsAndSuburbs",
		e,
		t,
		n
	], a[0] = e, a[1] = n, a[2] = t, a[3] = l) : l = a[3];
	let d = l, f;
	a[4] !== e || a[5] !== c || a[6] !== n || a[7] !== t ? (f = (r) => {
		let { signal: i } = r;
		return c.getPublishedListingsAgentsAndSuburbs(e, t, n, i);
	}, a[4] = e, a[5] = c, a[6] = n, a[7] = t, a[8] = f) : f = a[8];
	let p = s && !!c, m;
	a[9] !== d || a[10] !== f || a[11] !== p ? (m = {
		queryKey: d,
		queryFn: f,
		enabled: p
	}, a[9] = d, a[10] = f, a[11] = p, a[12] = m) : m = a[12];
	let { data: h, isPending: g, isError: _ } = u(m), v;
	return a[13] !== h || a[14] !== _ || a[15] !== g ? (v = {
		data: h,
		isPending: g,
		isError: _
	}, a[13] = h, a[14] = _, a[15] = g, a[16] = v) : v = a[16], v;
}, he = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r) => {
		await t.invalidateQueries({ queryKey: [
			"getPublishedListingsAgentsAndSuburbs",
			e,
			n,
			r
		] });
	}, e[0] = t, e[1] = n), n;
}, ge = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => {
		let { agencyId: t, body: n } = e;
		return a.rexBrandAccountWebhook(t, n);
	}, t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		rexBrandAccountWebhook: u,
		rexBrandAccountWebhookPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, _e = (e, t, n, i, a, s) => {
	let c = r(21), l = s === void 0 ? !0 : s, d = o(L), f;
	c[0] !== e || c[1] !== t || c[2] !== a || c[3] !== i || c[4] !== n ? (f = [
		"staffGetLeaderboardStatistics",
		e,
		t,
		n,
		i,
		a
	], c[0] = e, c[1] = t, c[2] = a, c[3] = i, c[4] = n, c[5] = f) : f = c[5];
	let p = f, m;
	c[6] !== d || c[7] !== e || c[8] !== t || c[9] !== a || c[10] !== i || c[11] !== n ? (m = (r) => {
		let { signal: o } = r;
		return d.staffGetLeaderboardStatistics(e, t, n, i, a, o);
	}, c[6] = d, c[7] = e, c[8] = t, c[9] = a, c[10] = i, c[11] = n, c[12] = m) : m = c[12];
	let h = l && !!d, g;
	c[13] !== p || c[14] !== m || c[15] !== h ? (g = {
		queryKey: p,
		queryFn: m,
		enabled: h
	}, c[13] = p, c[14] = m, c[15] = h, c[16] = g) : g = c[16];
	let { data: _, isPending: v, isError: y } = u(g), b;
	return c[17] !== _ || c[18] !== y || c[19] !== v ? (b = {
		data: _,
		isPending: v,
		isError: y
	}, c[17] = _, c[18] = y, c[19] = v, c[20] = b) : b = c[20], b;
}, ve = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r, i, a) => {
		await t.invalidateQueries({ queryKey: [
			"staffGetLeaderboardStatistics",
			e,
			n,
			r,
			i,
			a
		] });
	}, e[0] = t, e[1] = n), n;
}, ye = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.exportNetworkItemizedTransactions(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		exportNetworkItemizedTransactions: u,
		exportNetworkItemizedTransactionsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, be = (e, t, n, i) => {
	let a = r(17), s = i === void 0 ? !0 : i, c = o(L), l;
	a[0] !== n || a[1] !== t || a[2] !== e ? (l = [
		"getContractCommissionDiscrepancies",
		e,
		t,
		n
	], a[0] = n, a[1] = t, a[2] = e, a[3] = l) : l = a[3];
	let d = l, f;
	a[4] !== c || a[5] !== n || a[6] !== t || a[7] !== e ? (f = (r) => {
		let { signal: i } = r;
		return c.getContractCommissionDiscrepancies(e, t, n, i);
	}, a[4] = c, a[5] = n, a[6] = t, a[7] = e, a[8] = f) : f = a[8];
	let p = s && !!c, m;
	a[9] !== d || a[10] !== f || a[11] !== p ? (m = {
		queryKey: d,
		queryFn: f,
		enabled: p
	}, a[9] = d, a[10] = f, a[11] = p, a[12] = m) : m = a[12];
	let { data: h, isPending: g, isError: _ } = u(m), v;
	return a[13] !== h || a[14] !== _ || a[15] !== g ? (v = {
		data: h,
		isPending: g,
		isError: _
	}, a[13] = h, a[14] = _, a[15] = g, a[16] = v) : v = a[16], v;
}, $ = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r) => {
		await t.invalidateQueries({ queryKey: [
			"getContractCommissionDiscrepancies",
			e,
			n,
			r
		] });
	}, e[0] = t, e[1] = n), n;
}, xe = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(L), s;
	n[0] === e ? s = n[1] : (s = ["getExecutiveKeyMetrics", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getExecutiveKeyMetrics(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, Se = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getExecutiveKeyMetrics", e] });
	}, e[0] = t, e[1] = n), n;
}, Ce = (e, t) => {
	let n = r(13), i = t === void 0 ? !0 : t, a = o(L), s;
	n[0] === e ? s = n[1] : (s = ["getExecutiveRunRateMetrics", e], n[0] = e, n[1] = s);
	let c = s, l;
	n[2] !== a || n[3] !== e ? (l = (t) => {
		let { signal: n } = t;
		return a.getExecutiveRunRateMetrics(e, n);
	}, n[2] = a, n[3] = e, n[4] = l) : l = n[4];
	let d = i && !!a, f;
	n[5] !== c || n[6] !== l || n[7] !== d ? (f = {
		queryKey: c,
		queryFn: l,
		enabled: d
	}, n[5] = c, n[6] = l, n[7] = d, n[8] = f) : f = n[8];
	let { data: p, isPending: m, isError: h } = u(f), g;
	return n[9] !== p || n[10] !== h || n[11] !== m ? (g = {
		data: p,
		isPending: m,
		isError: h
	}, n[9] = p, n[10] = h, n[11] = m, n[12] = g) : g = n[12], g;
}, we = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e) => {
		await t.invalidateQueries({ queryKey: ["getExecutiveRunRateMetrics", e] });
	}, e[0] = t, e[1] = n), n;
}, Te = (e, t, n, i) => {
	let a = r(17), s = i === void 0 ? !0 : i, c = o(L), l;
	a[0] !== n || a[1] !== t || a[2] !== e ? (l = [
		"getListingDiscrepancies",
		e,
		t,
		n
	], a[0] = n, a[1] = t, a[2] = e, a[3] = l) : l = a[3];
	let d = l, f;
	a[4] !== c || a[5] !== n || a[6] !== t || a[7] !== e ? (f = (r) => {
		let { signal: i } = r;
		return c.getListingDiscrepancies(e, t, n, i);
	}, a[4] = c, a[5] = n, a[6] = t, a[7] = e, a[8] = f) : f = a[8];
	let p = s && !!c, m;
	a[9] !== d || a[10] !== f || a[11] !== p ? (m = {
		queryKey: d,
		queryFn: f,
		enabled: p
	}, a[9] = d, a[10] = f, a[11] = p, a[12] = m) : m = a[12];
	let { data: h, isPending: g, isError: _ } = u(m), v;
	return a[13] !== h || a[14] !== _ || a[15] !== g ? (v = {
		data: h,
		isPending: g,
		isError: _
	}, a[13] = h, a[14] = _, a[15] = g, a[16] = v) : v = a[16], v;
}, Ee = () => {
	let e = r(2), t = d(), n;
	return e[0] === t ? n = e[1] : (n = async (e, n, r) => {
		await t.invalidateQueries({ queryKey: [
			"getListingDiscrepancies",
			e,
			n,
			r
		] });
	}, e[0] = t, e[1] = n), n;
}, De = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.getNetworkPartnershipMetrics(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		getNetworkPartnershipMetrics: u,
		getNetworkPartnershipMetricsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
}, Oe = (e) => {
	let t = r(9), { onSuccess: n, onError: i } = e, a = o(L), s;
	t[0] === a ? s = t[1] : (s = async (e) => a.getNetworkStateMetrics(e), t[0] = a, t[1] = s);
	let c;
	t[2] !== i || t[3] !== n || t[4] !== s ? (c = {
		mutationFn: s,
		onSuccess: n,
		onError: i
	}, t[2] = i, t[3] = n, t[4] = s, t[5] = c) : c = t[5];
	let { mutateAsync: u, isPending: d } = l(c), f;
	return t[6] !== u || t[7] !== d ? (f = {
		getNetworkStateMetrics: u,
		getNetworkStateMetricsPending: d
	}, t[6] = u, t[7] = d, t[8] = f) : f = t[8], f;
};
//#endregion
export { h as ContractDateToUse, v as CreateLeadRequestEnquiryType, y as ExecutiveMetricsResponseContractType, b as GetMetricsRequestTimePeriod, x as KeyMetricMetricType, m as ListingCategories, p as ListingState, S as PartnershipDetailsPartnershipLevel, C as PartnershipInformationPartnershipLevel, w as PartnershipTierLevel, T as PublishedListingModelOverridenListingStatus, L as RexApiContext, k as RexApiException, R as RexApiProvider, f as RexClient, E as RexLinkLinkType, M as RexRoute, ee as RunRateMetricMetricType, D as StatisticsForEntityRequestEntityType, O as StatisticsForEntityRequestTimePeriod, _ as StatisticsTimePeriod, g as StatisticsType, ue as useCreateLead, ye as useExportNetworkItemizedTransactions, z as useGetActiveListingsForAgency, V as useGetAgencyListingsPermanentLinkModel, U as useGetAgentRexDetails, be as useGetContractCommissionDiscrepancies, xe as useGetExecutiveKeyMetrics, Ce as useGetExecutiveRunRateMetrics, G as useGetLeaderboardStatisticsForEntity, K as useGetListingByCampaignId, Te as useGetListingDiscrepancies, De as useGetNetworkPartnershipMetrics, Oe as useGetNetworkStateMetrics, J as useGetPartnershipInformation, de as useGetPublishedListingDetail, pe as useGetPublishedListingDetails, me as useGetPublishedListingsAgentsAndSuburbs, Y as useGetStatisticsForEntity, X as useGetSuburbs, te as useGetTopPerformers, B as useInvalidateUseGetActiveListingsForAgency, H as useInvalidateUseGetAgencyListingsPermanentLinkModel, W as useInvalidateUseGetAgentRexDetails, $ as useInvalidateUseGetContractCommissionDiscrepancies, Se as useInvalidateUseGetExecutiveKeyMetrics, we as useInvalidateUseGetExecutiveRunRateMetrics, q as useInvalidateUseGetListingByCampaignId, Ee as useInvalidateUseGetListingDiscrepancies, fe as useInvalidateUseGetPublishedListingDetail, he as useInvalidateUseGetPublishedListingsAgentsAndSuburbs, Z as useInvalidateUseGetTopPerformers, re as useInvalidateUseStaffGetAgencyPartnershipDetails, ae as useInvalidateUseStaffGetCurrentPartnershipInformation, ve as useInvalidateUseStaffGetLeaderboardStatistics, ce as useInvalidateUseStaffGetUpcomingSettlementsForAgency, ge as useRexBrandAccountWebhook, I as useRexClientContext, Q as useSetListingPublishedToPortal, ne as useStaffGetAgencyPartnershipDetails, ie as useStaffGetCurrentPartnershipInformation, oe as useStaffGetEntityNumbers, _e as useStaffGetLeaderboardStatistics, se as useStaffGetUpcomingSettlementsForAgency, le as useUpdateAgentRexDetails };
